import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="mb-0" style={{ color: "black" }}>
      <div className="container py-3 py-md-4">
        <div className="text-center">
          {/* Brand Logo */}
          <div className="d-flex justify-content-center align-items-center brand">
            <img src="/img/logo.png" alt="Carloca Logo" />
            <h2 className="blue ms-2 mb-0">Carloca</h2>
          </div>

          {/* About Text */}
          <p className="m-0 sml">
            Carloca is your trusted platform for buying and selling both new and old cars.  
            Whether you’re looking to upgrade, trade in, or find your dream car, we make the process
            simple, secure, and hassle-free.
          </p>

          {/* Social Media Icons */}
          <ul className="d-flex justify-content-center align-items-center flex-wrap all_media_icons p-0 m-0 py-2">
            {/* <li><Link to="#"><img src="img/foot-msg.png" alt="Message" /></Link></li>
            <li><Link to="#"><img src="img/foot-fb.png" alt="Facebook" /></Link></li> */}
            <li><Link to="https://www.instagram.com/carloca.uk/"><img src="/img/foot-insta.png" alt="Instagram" /></Link></li>
          </ul>

          {/* Copyright */}
          <p className="text-center m-0 sml">Copyright &copy; {new Date().getFullYear()} - carloca.co.uk</p>

          {/* Footer Links */}
          <div className="d-flex justify-content-center align-items-center mt-2">
            <ul className="p-0 d-flex justify-content-center flex-wrap policies m-0 sml">
              <li className="m-2">
                <Link to="/privacy" className="text-decoration-none">Imprint / Privacy</Link> &nbsp;|
              </li>
              <li className="m-2">
                <Link to="/term-and-condition" className="text-decoration-none">Terms &amp; Conditions</Link> &nbsp;|
              </li>
              <li className="m-2">
                <Link to="/feedback" className="text-decoration-none">Feedback</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
